import { IsServiceModeValid } from './types';

// for PLK the service mode validation is deactivated
export const isServiceModeValid: IsServiceModeValid = () => true;
